import React from 'react'
import {
    ZuiEwiqDialog,
    ZuiEwiqDialogHeadline,
    ZuiEwiqDialogDescription,
    ZuiEwiqDialogButtons,
    ZuiDialogButton,
} from '@zeiss/zui-react'
import Modal from 'components/Modals'
import './confirmationModal.css'

const index = ({ isOpen, title, message, onConfirm, onDismiss, buttons }) => {
    return (
        <>
            {isOpen && (
                <Modal style={{ zIndex: 999 }}>
                    <ZuiEwiqDialog state="question">
                        <ZuiEwiqDialogHeadline slot="headerText">{title}</ZuiEwiqDialogHeadline>
                        <ZuiEwiqDialogDescription slot="questionText">
                            {message}
                        </ZuiEwiqDialogDescription>
                        <ZuiEwiqDialogButtons slot="footer" primaryPosition="last" role="button">
                            <ZuiDialogButton
                                onClick={onDismiss}
                                emphasis="default"
                                style={{ borderRight: '1px solid #DDE3ED' }}
                            >
                                {buttons ? buttons[0] : 'Cancel'}
                            </ZuiDialogButton>
                            <ZuiDialogButton emphasis="primary-highlight" onClick={onConfirm}>
                                {buttons ? buttons[1] : 'Confirm'}
                            </ZuiDialogButton>
                        </ZuiEwiqDialogButtons>
                    </ZuiEwiqDialog>
                </Modal>
            )}
        </>
    )
}

export default index
